const Contact = () => {
    const emailAddress = "freiwaldcup2023@gmail.com";
    return (
        <div className="m-3">
            <h1>Union Schönau</h1>
            <a href={`mailto:${emailAddress}`}>E-Mail an {emailAddress} senden</a>
        </div>
    )
}

export default Contact;